import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ArrowUpRightIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { PageHeader } from '../components/shared/PageHeader';
import { QuoteForm } from '../components/shared/QuoteForm';
import { company } from '../data/company';
import { products } from '../data/products';
import { images } from '../data/images';
export function Contact() {
  const [params] = useSearchParams();
  const productSlug = params.get('product');
  const initialProduct = products.find(product => product.slug === productSlug)?.name ?? '';
  const details = [{
    label: 'Address',
    icon: MapPinIcon,
    content: company.addressLines.join(', '),
    href: undefined
  }, {
    label: 'Phone',
    icon: PhoneIcon,
    content: company.phone,
    href: company.phoneHref
  }, {
    label: 'Email',
    icon: MailIcon,
    content: company.email,
    href: company.emailHref
  }];
  return <>
      <PageHeader crumb="Contact Us" title="Contact Us" subtitle="Send us your specification and we will reply with the right material and a quotation." image={images.stretchFilm} data-id="element-301" data-mp="aablwxoz4lq3" />

      <section className="bg-ink py-20 md:py-28" data-id="element-302" data-mp="19f7h8mmvx3ic">
        <div className="mx-auto grid max-w-[1320px] gap-10 px-5 md:px-8 lg:grid-cols-12 lg:gap-14" data-id="element-303" data-mp="1e78pzykugc3m">
          <div className="lg:col-span-5" data-id="element-304" data-mp="1j7d97wd4zkxj">
            <ul className="space-y-3" data-id="element-305" data-mp="1j621xmkhfv1o">
              {details.map(({
              label,
              icon: Icon,
              content,
              href
            }) => <li key={label} className="flex gap-4 rounded-2xl border border-edge bg-coal p-5" data-id="element-306" data-mp="minqk3toqoai">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-flame text-ink" data-id="element-307" data-mp="qk8ydard4cdu">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-308" data-mp="10gc5yw4zh386" />
                  </span>
                  <div className="min-w-0" data-id="element-309" data-mp="26wejzq9fz85z">
                    <h2 className="text-xs font-bold uppercase tracking-[0.12em] text-muted" data-id="element-310" data-mp="26vcy0qqw119h">{label}</h2>
                    {href ? <a href={href} className="mt-1 block break-all text-lg font-semibold text-chalk transition-colors duration-150 hover:text-flame" data-id="element-311" data-mp="2bxlptjs0xxa0">
                        {content}
                      </a> : <address className="mt-1 text-lg font-semibold not-italic leading-snug text-chalk" data-id="element-312" data-mp="1w62ud8ue13x7">{content}</address>}
                  </div>
                </li>)}
            </ul>

            <div className="mt-6 overflow-hidden rounded-[24px] border border-edge" data-id="element-313" data-mp="13hx9mm3c3exd">
              <iframe title="Map of Universal Packaging Industries in Umm Al Quwain" src={company.mapEmbed} className="aspect-[4/3] w-full border-0" style={{
              filter: 'grayscale(1) invert(0.92) contrast(0.9)'
            }} loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-314" data-mp="yikcn8ir0rh2" />
            </div>
            <div className="text-center lg:text-left" data-id="element-315" data-mp="fs2z4b6hm2ga">
              <a href={company.directions} target="_blank" rel="noreferrer" className="mt-5 inline-flex h-12 items-center gap-2 rounded-full border-2 border-flame px-6 text-sm font-bold uppercase tracking-[0.06em] text-chalk transition-colors duration-150 hover:bg-flame hover:text-ink" data-id="element-316" data-mp="fpgrycnidoyl">
                Get Directions
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-317" data-mp="2md7cg7jnfq8i" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-7" data-id="element-318" data-mp="3f3z3yrprrqpi">
            <div className="rounded-2xl bg-flame px-6 py-5 text-center text-ink lg:text-left" data-id="element-319" data-mp="3f3pd71wwhfir">
              <h2 className="font-display text-2xl font-bold uppercase" data-id="element-320" data-mp="313od3oogmc4c">Before you enquire</h2>
              <p className="mt-1.5 font-medium leading-relaxed" data-id="element-321" data-mp="354qdw9y0yw8f">
                Quotes are faster when you include product name, size or dimensions, grade or thickness, quantity and
                delivery location. Attach a spec sheet or drawing if you have one.
              </p>
            </div>
            <div className="mt-6 rounded-[28px] border border-edge bg-coal p-5 sm:p-10" data-id="element-322" data-mp="29ysr7g8659ff">
              <h2 className="text-center font-display text-4xl font-bold uppercase text-chalk md:text-5xl lg:text-left" data-id="element-323" data-mp="2569cuh1nqa9k">
                Enquiry form
              </h2>
              <div className="mt-8" data-id="element-324" data-mp="1v9eimacf2w13">
                <QuoteForm initialProduct={initialProduct} data-id="element-325" data-mp="1vafrq99vh8g6" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}